module.exports = __webpack_public_path__ + "static/media/user-password-settings.f1be1875.svg";